import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { createApiUrl } from '../utils/apiConfig';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { isAuthenticated, user } = useAuth();
  const [hasPublishedArticles, setHasPublishedArticles] = useState(false);

  useEffect(() => {
    const checkPublishedArticles = async () => {
      try {
        const response = await axios.get(createApiUrl('/api/news/articles/published'));
        setHasPublishedArticles(response.data && response.data.length > 0);
      } catch (error) {
        // If there's an error, assume no articles exist
        console.error('Error checking published articles:', error);
        setHasPublishedArticles(false);
      }
    };

    checkPublishedArticles();
  }, []);

  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="custom-navbar">
      <Navbar.Brand as={Link} to="/">
        <img
          src="/img/kbhClassroomLogo.png"
          height="60"
          className="d-inline-block align-top"
          alt="KBH Classroom Logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto">
          {currentPath !== '/' && (
            <Nav.Link as={Link} to="/" className="custom-nav-link">Home</Nav.Link>
          )}
          {currentPath !== '/contact' && (
            <Nav.Link as={Link} to="/contact" className="custom-nav-link">Contact</Nav.Link>
          )}
          {currentPath !== '/kbh-curriculum' && (
            <Nav.Link as={Link} to="/kbh-curriculum" className="custom-nav-link">KBH Curriculum</Nav.Link>
          )}
          {hasPublishedArticles && currentPath !== '/news' && (
            <Nav.Link as={Link} to="/news" className="custom-nav-link">News</Nav.Link>
          )}
          {/* {currentPath !== '/resources' && (
            <Nav.Link as={Link} to="/resources" className="custom-nav-link">Resources</Nav.Link>
          )} */}
          
          {/* Authenticated User Navigation */}
          {isAuthenticated ? (
            <>
              {user && (user.isAdmin || user.role === 'admin') && currentPath !== '/admin-dashboard' && (
                <Nav.Link as={Link} to="/admin-dashboard" className="custom-nav-link">Admin Dashboard</Nav.Link>
              )}
              {user && (user.isAdmin || user.role === 'admin') && currentPath !== '/news-admin' && (
                <Nav.Link as={Link} to="/news-admin" className="custom-nav-link">News Admin</Nav.Link>
              )}
              {user && user.isOrgAdmin && currentPath !== '/org-admin-dashboard' && (
                <Nav.Link as={Link} to="/org-admin-dashboard" className="custom-nav-link">Org Admin</Nav.Link>
              )}
              {user && user.isSchAdmin && currentPath !== '/school-admin-dashboard' && (
                <Nav.Link as={Link} to="/school-admin-dashboard" className="custom-nav-link">School Admin</Nav.Link>
              )}
              {/* Show Teacher Dashboard for all regular users (teachers) */}
              {user && !user.isAdmin && !user.isOrgAdmin && !user.isSchAdmin && currentPath !== '/teacher-dashboard' && (
                <Nav.Link as={Link} to="/teacher-dashboard" className="custom-nav-link">Teacher Dashboard</Nav.Link>
              )}
              {/* Show generic Dashboard link only for regular users (not admins) */}
              {user && !user.isAdmin && !user.isOrgAdmin && !user.isSchAdmin && currentPath !== '/dashboard' && (
                <Nav.Link as={Link} to="/dashboard" className="custom-nav-link">Dashboard</Nav.Link>
              )}
              <Nav.Link as={Link} to="/logout" className="custom-nav-link">Logout</Nav.Link>
            </>
          ) : (
            currentPath !== '/login' && (
              <Nav.Link as={Link} to="/login" className="custom-nav-link">Login</Nav.Link>
            )
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Navigation; 